import { render, staticRenderFns } from "./mod18.vue?vue&type=template&id=5d4c36af&scoped=true&"
import script from "./mod18.vue?vue&type=script&lang=js&"
export * from "./mod18.vue?vue&type=script&lang=js&"
import style0 from "./mod18.vue?vue&type=style&index=0&id=5d4c36af&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d4c36af",
  null
  
)

export default component.exports